import { cn } from "@/lib/utils/global-utils";
import { cva, VariantProps } from "class-variance-authority";
import React from "react";

const pageVariants = cva("", {
  variants: {
    variant: {
      padded: " p-default ",
    },
    size: {
      full: " size-full ",
    },
  },
});

export interface PageProps
  extends React.HtmlHTMLAttributes<HTMLDivElement>,
    VariantProps<typeof pageVariants> {}

/**
 * # Page
 *  Page component that supports different layout and style variants.
 * ## Defined Themes/Properties
 *  -  `variant`: The layout variant of the page.
 *      -  **default**: p-4
 *  -   `size`: The size of the page.
 *      -  **full**: w-full h-full
 * ### Details
 * @param {PageProps} props - The props for the Page component.
 * @returns {JSX.Element} A customizable Page component.
 *
 *
 * @example
 * <Page variant="default" size="full" className="custom-class">
 *   Content here
 * </Page>
 */
const Page = React.forwardRef<HTMLDivElement, PageProps>(
  ({ className, variant, size, ...rest }, ref) => {
    return (
      <div
        ref={ref}
        {...rest}
        className={cn(pageVariants({ variant, size, className }))}
      />
    );
  }
);

Page.displayName = "Page";

export { Page, pageVariants };
